import type { FaireProductEntity } from "../../entity_types/product";

export const p_z9pxy3nn7g: FaireProductEntity = {
  token: "p_z9pxy3nn7g",
  type: "product",
  name: "Crispy Cinnamon Crunch Cookies - 6.3 oz box",
  brandToken: "b_1q83xmlpct",
  brandName: "Maxine's Heavenly",
  imageUrl: "https://cdn.faire.com/fastly/5f8f89cec2a7d9c2407ffb7b256d262ebf6f8f304a94bb5e3413d1b812b3d1b9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b91f5d978f6fafd27b77850e3cc6f8b013242b8b7fa7b4001ab4c630718d3d01.jpeg",
    "https://cdn.faire.com/fastly/140866e8f4936c5ee3592e25b50a887a75279162f8640df94ca56a3228af43b6.jpeg",
    "https://cdn.faire.com/fastly/11fa72a31378acc333f4fd8c536b6edf9231eb13554e8a8bfcdeaa185f9274be.jpeg",
    "https://cdn.faire.com/fastly/977c2427acf8d2af8dd666c63e55aa3d45fb2adcfc071567ae17bc4586eb9918.jpeg",
    "https://cdn.faire.com/fastly/a85215898beb4941735f7678e45612b8c19f9e7dadc09931cd121f07e1170418.jpeg"
  ],
  priceDollars: 5.81,
  description: "CRISP & COZY. This delicate, buttery cookie has notes of brown sugar and all your favorite spices: cinnamon, nutmeg, cloves, and cardamom.\n\nSWEETENED BY NATURE. We sweeten with coconut sugar \nTASTES HOMEMADE. Our cookies hold true to mom’s homemade cookie experience.\nBETTER-FOR-YOU. No empty calories! Just nutrient-rich ingredients like whole-grain oats.\nMADE FOR MORE TO ENJOY. Low sugar and certified gluten free, vegan, kosher, and non-GMO.\n\nShelf life - 8 months\n6.3 oz",
  tags: [],
  msrpDollars: 9.69,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:54.783Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
